import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { Modal } from "app/components/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { valueForOnlyStringInputTextFields } from "utils/helpers";

import {
  selectIsAddModalOpen,
  selectManufacturerForm,
  selectManufacturersLoading,
} from "../../redux/selector";
import { manufacturerActions } from "../../redux/slice";
import { useStyles } from "./style";

const AddManufacturerModal = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const form = useSelector(selectManufacturerForm);
  const isLoading = useSelector(selectManufacturersLoading);
  const isOpen = useSelector(selectIsAddModalOpen);

  const onClose = () => {
    if (isLoading) return;
    dispatch(manufacturerActions.resetForm());
    dispatch(manufacturerActions.closeAddModal());
  };

  const isValid = Boolean(form.menufecturerName.trim());

  const onSubmit = () => {
    if (!isValid) return;
    dispatch(manufacturerActions.createManufacturer(form));
    dispatch(manufacturerActions.closeAddModal());
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box className={styles.modal} sx={{ direction: i18n.dir() }}>
        <Box className={styles.header}>
          <Typography className={styles.title}>
            {t("MANUFACTURERS.MODAL.ADD_TITLE")}
          </Typography>
          <IconButton
            className={styles.closeButton}
            onClick={onClose}
            disabled={isLoading}
            aria-label={t("BUTTONS.CANCEL")}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          <Typography className={styles.label}>
            {t("MANUFACTURERS.TABLE.MANUFACTURER_NAME")}
          </Typography>
          <TextField
            className={styles.input}
            fullWidth
            variant="outlined"
            placeholder={t("MANUFACTURERS.MODAL.NAME_PLACEHOLDER")}
            value={form.menufecturerName}
            InputProps={{ notched: false }}
            disabled={isLoading}
            onChange={(e) =>
              dispatch(
                manufacturerActions.setFormField({
                  name: "menufecturerName",
                  value: valueForOnlyStringInputTextFields(e.target.value),
                }),
              )
            }
          />
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            disabled={isLoading}
            onClick={onClose}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!isValid || isLoading}
            onClick={onSubmit}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddManufacturerModal;
